/**
 * Created by Karol Kluska on 12.06.17.
 */

angular
  .module('app')
  .component('rateplanAvailabilityCalendar', {
    controller: Calendar,
    bindings: {
      month: '<',
      offers: '<',
      isFullyRestricted: '<',
      inRow: '<',
      currencyPrefix: '<',
      currencySuffix: '<'
    },
    templateUrl: 'app/shared/rateplanAvailability/calendar/Calendar.html'
  });

function Calendar($translate) {
  var $this = this;
  $this.$translate = $translate;
}

Calendar.prototype = {
  $onChanges: function (changes) {
    if ((angular.isDefined(changes.offers) && angular.isDefined(changes.offers.currentValue))) {
      this.days = [];
      this.daysInMonth = moment(this.month).daysInMonth();
      this.firstDayOfMonth = moment(this.month).startOf('month');
      this.lastDayOfMonth = moment(this.month).endOf('month');
      this.weeksInMonth = this.getNumberOfWeekInMonth(this.lastDayOfMonth);
      this.updateDays();
      this.weeks = this.getWeeks();
    }
  },

  updateDays: function () {
    for (var i = 0; i < this.daysInMonth; i++) {
      var date = moment(this.firstDayOfMonth).add(i, 'days');
      var yesterdayOffer = this.getOffer(moment(date).subtract(1, 'day'));
      var todayOffer = this.getOffer(moment(date));
      var hasAllotmentToday = todayOffer.allotment > 0;
      var hasAllotmentYesterday = yesterdayOffer.allotment > 0;
      var isOccupiedStart;
      var isOccupied;
      var isOccupiedEnd;
      var isPast = moment(date).isBefore(moment(), 'day');
      if (this.isFullyRestricted) {
        isOccupiedStart = (hasAllotmentYesterday && !yesterdayOffer.closed && !yesterdayOffer.not_synchronize && yesterdayOffer.price > 0) && (!hasAllotmentToday || todayOffer.closed || todayOffer.not_synchronize || todayOffer.price <= 0);
        isOccupied = (!hasAllotmentYesterday || yesterdayOffer.closed || yesterdayOffer.not_synchronize || yesterdayOffer.price <= 0) && (!hasAllotmentToday || todayOffer.closed || todayOffer.not_synchronize || todayOffer.price <= 0);
        isOccupiedEnd = (!hasAllotmentYesterday || yesterdayOffer.closed || yesterdayOffer.not_synchronize || yesterdayOffer.price <= 0) && (hasAllotmentToday && !todayOffer.closed && !todayOffer.not_synchronize && todayOffer.price > 0);
      } else {
        isOccupiedStart = hasAllotmentYesterday && !hasAllotmentToday;
        isOccupied = !hasAllotmentYesterday && !hasAllotmentToday;
        isOccupiedEnd = !hasAllotmentYesterday && hasAllotmentToday;
      }
      var isFree = !isOccupiedStart && !isOccupied && !isOccupiedEnd && todayOffer.allotment > 0;
      this.days[i] = {};
      this.days[i].date = moment(date).format('YYYY-MM-DD');
      this.days[i].past = isPast;
      this.days[i].free = !isPast && isFree;
      this.days[i].occupiedStart = !isPast && isOccupiedStart;
      this.days[i].occupied = !isPast && isOccupied;
      this.days[i].occupiedEnd = !isPast && isOccupiedEnd;
      this.days[i].price = this.getPriceWithCurrency(this.currencyPrefix, this.currencySuffix, todayOffer.price);
    }
  },

  getNumberOfWeekInMonth: function (date) {
    return Math.ceil((moment(date).date() + this.firstDayOfMonth.isoWeekday() - 1) / 7);
  },

  getWeeks: function () {
    var result = {};
    for (var i = 0; i < this.weeksInMonth; i++) {
      result[i] = this.getDaysInWeek(i + 1);
    }
    return result;
  },

  getOffer: function (date) {
    date = moment(date).format('YYYY-MM-DD');
    return angular.isUndefined(this.offers[date]) ? {} : this.offers[date];
  },

  getDaysInWeek: function (week) {
    var $this = this;
    var days = $this.days.filter(function (day) {
      return $this.getNumberOfWeekInMonth(day.date) === week;
    });

    while (days.length < 7) {
      if (week === 1) {
        days.unshift({});
      } else {
        days.push({});
      }
    }

    return days;
  },

  getPriceWithCurrency: function (prefix, suffix, price) {
    if (angular.isUndefined(price) || price <= 0) {
      return;
    }
    var result = this.formatPrice(price).toString();
    if (angular.isDefined(prefix) && prefix !== null) {
      result = prefix + result;
    }
    if (angular.isDefined(suffix) && suffix !== null) {
      result += suffix;
    }
    return result;
  },

  formatPrice: function (price) {
    return Math.round(price * 100) / 100;
  },

  getYear: function (date) {
    return moment(date).year();
  },

  getMonthName: function (date) {
    var monthIndex = moment(date).month();
    var monthList = [
      this.$translate.instant('months.JANUARY'),
      this.$translate.instant('months.FEBRUARY'),
      this.$translate.instant('months.MARCH'),
      this.$translate.instant('months.APRIL'),
      this.$translate.instant('months.MAY'),
      this.$translate.instant('months.JUNE'),
      this.$translate.instant('months.JULY'),
      this.$translate.instant('months.AUGUST'),
      this.$translate.instant('months.SEPTEMBER'),
      this.$translate.instant('months.OCTOBER'),
      this.$translate.instant('months.NOVEMBER'),
      this.$translate.instant('months.DECEMBER')
    ];
    return monthList[monthIndex];
  },

  getWeekdays: function () {
    return [
      this.$translate.instant('weekdays_short.MON'),
      this.$translate.instant('weekdays_short.TUE'),
      this.$translate.instant('weekdays_short.WED'),
      this.$translate.instant('weekdays_short.THU'),
      this.$translate.instant('weekdays_short.FRI'),
      this.$translate.instant('weekdays_short.SAT'),
      this.$translate.instant('weekdays_short.SUN')
    ];
  }
};
